<template>
<div class="chapter">
<div class="inner_page">
<p class="noindents"><a id="preface03"></a><a id="page_xi"><span class="txbf">One-Eyed Jack:</span> \w<img alt="e" height="14" src="images/e.jpg" width="12"/>n\-\'īd\-\'jak\</a></p><a id="page_xi">
</a><p class="noindent"><a id="page_xi"><span class="txbf">Noun: 1:</span> being, of, pertaining to, a face card or cards on which the figure is shown in profile, such cards being the jack of spades, the jack of hearts. <span class="txbf">2:</span> a loner who has a hard time trusting anyone. <span class="txbf">3:</span> Navy term for a greasy hamburger topped with a fried egg. Often served during midrats—midnight rations.</a><a id="page_xii"></a></p><a id="page_xii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface03.vue?72308302